<li ngbDropdown class="nav-item dropdown-notification mr-25">
  <a class="nav-link" ngbDropdownToggle id="navbarNotificationDropdown"><i class="ficon" data-feather="bell"></i><span
      class="badge badge-pill badge-danger badge-up"><!-- {{customerEmployeeTrackingResultList.paginationInformation.TotalCount}} --></span></a>
  <ul ngbDropdownMenu aria-labelledby="navbarNotificationDropdown"
    class="dropdown-menu dropdown-menu-media dropdown-menu-right">
    <!-- Notifications header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">{{'Notifications' | translate}}</h4>
        <div class="badge badge-pill badge-light-primary">
          <!-- {{ customerEmployeeTrackingResultList.paginationInformation.TotalCount }} {{'New' | translate}} -->
        </div>
      </div>
    </li>
    <!--/ Notifications header -->
    <!-- Notifications content -->
    <!-- <li class="scrollable-container media-list" [perfectScrollbar]>
      <a class="d-flex" href="javascript:void(0)" *ngFor="let item of customerEmployeeTrackingResultList.data">
        <div class="media d-flex align-items-start">
          <div class="media-left">
            <div class="avatar bg-light-warning">
              <div class="avatar-content"><i class="avatar-icon"></i></div>
            </div>
          </div>
          <div class="media-body">
            <p class="media-heading">{{ item.EmployeeFullName }} - {{ item.CustomerEmployeeName }}</p>
            <small class="notification-text">{{ item.Subject }}</small>
          </div>
        </div>
      </a>
    </li> -->
    <!--/ Notifications content -->
    <!-- Notifications footer -->
    <li class="dropdown-menu-footer">
      <a class="btn btn-primary btn-block"
        [routerLink]="['pages/customerEmployee-tracking-list', {notification:true}]">{{'ShowAllNotifications' | translate}}</a>
    </li>
    <!--/ Notifications footer -->
  </ul>
</li>